import axios from 'axios'
import settings from '../../settings'

const genres = {
    namespaced: true,
    state: () => ({
        all:[]
      }),
      mutations:{
         updateGenresState(state,data){
             state.all=data;
         }
      },
      actions: {
        fetchGenres({commit}){
            axios.get(`${settings.apiUrl}/genres`).then(res => {
					commit('updateGenresState',res.data)
			 });
        },
      },
    
      getters: {
           
      }
}

export default genres;

 